import {
  Calendar,
  DayValue,
} from "@hassanmojab/react-modern-calendar-datepicker";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import jalaali from "jalaali-js";
import { useState } from "react";

import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";

import CalendarSearch from "../../../media/images/icons/calendar-search";
import MultipleSimple from "../../../media/images/icons/multiple-simple";

const style = {
  position: "absolute" as "absolute",
  display: "flex",
  flexDirection: "column",
  left: "50%",
  top: "50%",
  flex: "1",
  transform: "translate(-50%, -50%)",
  maxWidth: 400,
  minWidth: 350,
  maxHeight: "500px",
  bgcolor: "background.default",
  boxShadow: 24,
  borderRadius: "15px",
  p: 2,
};

const CustomDatePicker = (props: {
  error?: any;
  errorMessage?: any;
  hasError?: string;
  label: string;
  value: DayValue | null;
  onChange: (value: DayValue) => void;
  handleResetDate?: () => void;
}) => {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState<DayValue>(props.value);
  const [today, setToday] = useState({
    day: jalaali.toJalaali(new Date()).jd,
    month: jalaali.toJalaali(new Date()).jm,
    year: jalaali.toJalaali(new Date()).jy,
  });

  const theme = useTheme();
  const handleClickOpen = (e: any) => {
    setOpen(true);
    e.target.blur();
  };

  const handleClose = () => {
    setOpen(false);
    setValue(undefined);
  };

  const minimumDate = {
    year: 1402,
    month: 4,
    day: 26,
  };

  // useEffect(() => {
  //   console.log(props.value);
  // }, [props.value]);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "4px",
      }}
    >
      <style>
        {`
        .Calendar {
        min-height:32em;
        }
          .Calendar__section {
          // padding:0px 20px;
          }
          
          `}
      </style>
      {/* <Typography variant="body2">{props.label}</Typography> */}
      <Box
        sx={{
          height: "48px",
          border: "1px solid gray",
          display: "flex",
          alignItems: "center",
          paddingX: "8px",
          borderRadius: "8px",
        }}
      >
        {props.value && (
          <IconButton
            onClick={() => props.handleResetDate && props.handleResetDate()}
            aria-label="delete"
            color="primary"
          >
            <MultipleSimple size={22} color={theme.palette.error.main} />
          </IconButton>
        )}
        <TextField
          value={
            props.value?.year
              ? props.value?.year +
                "/" +
                props.value?.month +
                "/" +
                props.value?.day
              : props.label
          }
          onClick={handleClickOpen}
          placeholder={props.label}
          sx={{
            width: "100%",
            height: "100%",

            "& .MuiOutlinedInput-notchedOutline": {
              border: "none !important",
              outline: "none !important",
              borderRadius: "0px",
              padding: 0,
            },
            "& .MuiInputBase-input": {
              height: "100%",
              border: "none !important",
              outline: "none !important",
              padding: 0,
              fontSize: "14px",
              color: "textColor.main",

              "&::placeholder": {
                fontSize: "12px",
              },
            },
            "& .MuiInputBase-root": {
              border: "none !important",
              outline: "none !important",
              height: "100%",
              paddingX: "0px",
              color: "info.dark",
            },
            border: "none",
          }}
        />

        <CalendarSearch color={theme.palette.textColor.main} />
      </Box>

      {props.error && (
        <Typography
          style={{
            padding: "0px",
            margin: "0px",
            color: "red",
            direction: "rtl",
            textAlign: "right",
            fontSize: 13,
          }}
        >
          {props.errorMessage}
        </Typography>
      )}
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          direction: "rtl",
        }}
      >
        <Box
          sx={{
            ...style,
            backgroundColor: "#fff",
          }}
        >
          <Typography
            fontSize={16}
            textAlign={"center"}
            color={"textColor.main"}
          >
            {props.label}
          </Typography>
          <Calendar
            value={value || props.value}
            onChange={setValue}
            colorPrimary={theme.palette.primary.main}
            // colorPrimaryLight="rgba(75, 207, 250, 0.4)"
            shouldHighlightWeekends
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            // minimumDate={today}
            locale={"fa"}
          />

          <Box
            sx={{
              display: "flex",
              gap: "8px",
              padding: "0px 16px",
            }}
          >
            <Button
              onClick={() => {
                props.onChange(value);
                handleClose();
              }}
            >
              تایید
            </Button>
            <Button onClick={() => setOpen(false)}>انصراف</Button>
            {/* <CustomButton
            onClick={() => setOpen(false)}
            type="outlined"
            title="انصراف"
            borderColor="primary.main"
            textColor="primary.main"
            bgColor={theme.palette.primary[50]}
            fSize="14px"
            px="6px"
            py="8px"
            borderRadius="6px"
            icon1={<CloseCircleSVG color={theme.palette.primary.main} />}
          />
          <CustomButton
            onClick={() => {
              props.onChange(value);
              handleClose();
            }}
            title="تایید"
            bgColor="primary.main"
            px="16px"
            py="8px"
            borderRadius="6px"
          /> */}
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default CustomDatePicker;
